function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBoldDownwardChevron = function SvgBoldDownwardChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "chevron-down-Filled",
    d: "m21.707 8.707-9 9a1 1 0 0 1-1.414 0l-9-9a1 1 0 1 1 1.414-1.414L12 15.586l8.293-8.293a1 1 0 1 1 1.414 1.414Z",
    style: {
      fill: "#41416e",
      strokeWidth: 1,
      stroke: "#41416e"
    }
  }));
};
export default SvgBoldDownwardChevron;